import { render, staticRenderFns } from "./VacancyDetailsView.htm?vue&type=template&id=b738c79a&scoped=true&"
import script from "./VacancyDetailsView.ts?vue&type=script&lang=js&"
export * from "./VacancyDetailsView.ts?vue&type=script&lang=js&"
import style0 from "./VacancyDetailsView.scss?vue&type=style&index=0&id=b738c79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b738c79a",
  null
  
)

export default component.exports